/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppUserDto } from '../../models/app-user-dto';

export interface UsersUserIdGet$Json$Params {
  userId: string;
}

export function usersUserIdGet$Json(http: HttpClient, rootUrl: string, params: UsersUserIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AppUserDto>> {
  const rb = new RequestBuilder(rootUrl, usersUserIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppUserDto>;
    })
  );
}

usersUserIdGet$Json.PATH = '/users/{userId}';
